import i18n from '@/i18n';
import { watch } from 'vue';
import { createRouter, createWebHashHistory } from 'vue-router';
import { setupRouterGuard } from './guard';
import * as routeUtil from './util';

// 添加更新标题的函数
const updateDocumentTitle = (title?: string) => {
  if (title) {
    const translatedTitle = i18n.global.t(title);
    document.title = `${translatedTitle} - CTC-NEXT`;
  } else {
    document.title = 'CTC-NEXT';
  }
};

const router = createRouter({
  history: createWebHashHistory(),
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/views/common/login/index.vue'),
      meta: {
        title: 'login.account.title',
      },
    },
    {
      path: '/feishu-redirect',
      name: 'Feishu Redirect',
      component: () => import('@/views/common/login/feishu/feishu-redirect.vue'),
    },
    {
      path: '/404',
      name: 'Not Found',
      component: () => import('@/views/common/404/index.vue'),
    },
    {
      path: '/403',
      name: 'Access Denied',
      component: () => import('@/views/common/403/index.vue'),
    },
    {
      path: '/testcase/mind/:projectId/:nodeId',
      name: 'TestCaseMind',
      component: () => import('@/sites/project/pages/dev/testcase/case-mind.vue'),
    },
    {
      path: '/workplace',
      name: 'workplace',
      component: () => import('@/views/workplace/index.vue'),
      meta: {
        title: 'workplace.title',
      },
    },
    {
      path: '/account',
      name: 'account',
      component: () => import('@/views/common/account/index.vue'),
      meta: {
        title: 'account.base.title',
      },
    },
    {
      // CTC 需求进度：从头像下拉进入，面向所有提交人（非 site 页面，公共可达，与 /account 同级）。
      path: '/my-work-item',
      name: 'my-work-item',
      component: () => import('@/views/my-work-item/index.vue'),
      meta: {
        title: 'CTC需求进度',
      },
    },
    {
      path: '/approval/detail/:id',
      name: 'approval-detail',
      component: () => import('@/views/approval/detail.vue'),
      meta: {
        title: '审核详情',
      },
    },
    {
      path: '/yolo-login',
      name: 'yolo-login',
      component: () => import('@/views/common/yoloLogin/index.vue'),
    },
    // 旧的独立AI分析页面已废弃，现在使用全局任务面板系统（抽屉形式）
    // {
    //   path: '/precision-new/ai-analysis',
    //   name: 'precision-new-ai-analysis',
    //   component: () => import('@/sites/precision-new/pages/ai-analysis/index.vue'),
    //   meta: {
    //     title: 'precision.new.ai.analysis',
    //   },
    // },
    {
      path: '/',
      redirect: '/workplace',
    },
    {
      path: '/:pathMatch(.*)*',
      redirect: '/404',
    },
  ],
});

// 修改路由守卫，使用新的updateDocumentTitle函数
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    updateDocumentTitle(to.meta.title as string);
  } else {
    updateDocumentTitle();
  }
  next();
});

// 添加语言变化的监听器
watch(i18n.global.locale, () => {
  const currentTitle = router.currentRoute.value.meta.title as string;
  updateDocumentTitle(currentTitle);
});

setupRouterGuard(router);

export default router;
export { routeUtil };
